import { useEffect } from "react";

const APP_NAME = "Silph Scope";

export function formatPageTitle(page?: string | null): string {
  const name = page?.trim();
  return name ? `${name} | ${APP_NAME}` : APP_NAME;
}

export function humanizeDashboardId(id: string): string {
  return id
    .split("-")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function useDocumentTitle(page?: string | null, active = true) {
  useEffect(() => {
    if (!active) return;
    document.title = formatPageTitle(page);
    return () => {
      document.title = APP_NAME;
    };
  }, [page, active]);
}
